import { Lucky7Page } from "../lucky7";

// casino/lucky7eu ("Lucky 7 - B") — same reference page as Lucky 7 (the API type comes from the route)
export default function Lucky7B() {
  return <Lucky7Page defaultType="lucky7eu" />;
}
